import graphql__03752275b48f00d06a03 from "./__generated__/ProfileContributions_user.graphql.js";import { useCallback, useMemo } from "react";
import { graphql, useFragment } from "react-relay";
import { Outlet } from "react-router";
import { defineMessages } from "react-intl";

import { ResourcesListProvider } from "../ResourcesList/resourcesList";
import { useFormatMessage } from "../Intl/Context";
import { useNavigateTo } from "../Routes/RoutesContext";
import ProfileContribution from "./ProfileContribution";

const ProfileContributions = props => {
  const user = useFragment(ProfileContributions_user, props.user);
  const { contributions } = user.profile;

  const t = useFormatMessage();
  const labels = {
    title: t(intlMessages.title),
    noContributions: t(intlMessages.noContributions),
    hint: t(intlMessages.hint)
  };

  const contributionsPerContribuable = useMemo(
    () =>
      contributions.reduce((groupedContributions, contribution) => {
        const { contribuable } = contribution;
        const { id: contribuableId } = contribuable;

        if (!groupedContributions[contribuableId]) {
          groupedContributions[contribuableId] = {
            contribuable: contribuable,
            contributions: []
          };
        }

        groupedContributions[contribuableId].contributions.push(contribution);

        return groupedContributions;
      }, {}),
    [contributions]
  );

  const navigateTo = useNavigateTo();
  const handleContributionClicked = useCallback(
    contribution => {
      const { slug: contributionSlug } = contribution;
      navigateTo("profileContribution", { contributionSlug });
    },
    [navigateTo]
  );

  return (
    <ResourcesListProvider>
      <div className="box padding-lg">
        <div className="row">
          <div className="col-12">
            <h2 className="text-subtitle-page margin-bottom-sm">{labels.title}</h2>

            {contributions.length === 0 && (
              <div className="margin-top-sm margin-bottom-md">
                {labels.noContributions}
              </div>
            )}

            {contributions.length > 0 && (
              <div className="margin-top-sm margin-bottom-md">{labels.hint}</div>
            )}

            {Object.values(contributionsPerContribuable).map(
              ({ contribuable, contributions }) => (
                <div
                  key={contribuable.id}
                  className="border-top padding-top-md margin-bottom-md"
                >
                  <div className="text-title-block margin-bottom-xs">
                    {contribuable.title}
                  </div>

                  <div className="boxes-list row">
                    {contributions.map(contribution => (
                      <div key={contribution.id} className="col-md-6">
                        <ProfileContribution
                          contribution={contribution}
                          theme={null}
                          className="box-shadow"
                          onClick={() => handleContributionClicked(contribution)}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      {/* Allow displaying contribution modals */}
      <Outlet />
    </ResourcesListProvider>
  );
};

const ProfileContributions_user = graphql__03752275b48f00d06a03;

export default ProfileContributions;

const intlMessages = defineMessages({
  title: {
    id: "profile.contributions.title",
    defaultMessage: "Mes contributions"
  },
  noContributions: {
    id: "profile.contributions.noContributions",
    defaultMessage: "Vous n'avez rédigé aucune contribution pour le moment."
  },
  hint: {
    id: "profile.contributions.hint",
    defaultMessage: `
      Vous trouverez ci-dessous vos contributions aux différents modules participatifs.
      Vous pouvez cliquer sur les contributions pour en voir le détail.
    `
  }
});
